import SimpleBadge from "@/app/components/ui/Badges/SimpleBadge";
import clsx from "clsx";
import { useCallback, useState } from "react";

const QUICK_FILTERS = [
  {
    id: "morning",
    label: "Morning (post 8am)",
    timeLabel: "8:30 AM",
    colorClassName: "text-[#A47A0D] bg-[#FFF2D1] ring-blue-500/10 text-xs font-semibold hover:opacity-70",
  },
  {
    id: "afternoon",
    label: "Afternoon (post 2pm)",
    timeLabel: "1:10 PM",
    colorClassName: "text-[#EA5400] bg-[#FFE9DD] text-xs font-semibold ring-indigo-500/10 hover:opacity-70",
  },
  {
    id: "evening",
    label: "Evening (post 6pm)",
    timeLabel: "5:10 PM",
    colorClassName: "text-[#477200] bg-[#EAFACE] ring-teal-500/10 text-xs font-semibold hover:opacity-70",
  },
  {
    id: "night",
    label: "Night (post 9pm)",
    timeLabel: "8:30 PM",
    colorClassName: "text-[#6C0076] bg-[#FDEDFF] ring-teal-500/10 text-xs font-semibold hover:opacity-70",
  },
];

const StaffCalendarQuickFilters = () => {
  const [activeFilterId, setActiveFilterId] = useState<string>("morning");

  const handleQuickFilterClick = useCallback((timeLabel: string) => {
    window.dispatchEvent(
      new CustomEvent("staff-calendar:scroll-to-time", {
        detail: { timeLabel },
      }),
    );
  }, []);

  return (
    <div className="-mx-1 flex w-full items-center gap-x-2 overflow-x-auto px-1 py-0.5 calendar-hide-scrollbar md:mx-0 md:w-auto md:justify-end md:overflow-visible md:px-0">
      {QUICK_FILTERS.map((filter) => (
        <button
          key={filter.id}
          type="button"
          className="flex shrink-0 items-center"
          onClick={() => {
            setActiveFilterId(filter.id);
            handleQuickFilterClick(filter.timeLabel);
          }}
        >
          <SimpleBadge
            colorClassName={clsx(
              filter.colorClassName,
              "whitespace-nowrap",
              activeFilterId === filter.id
                ? "ring-2 ring-black/20 shadow-sm scale-[1.01]"
                : "opacity-85 hover:opacity-100",
            )}
            label={filter.label}
          />
        </button>
      ))}
    </div>
  );
};

export default StaffCalendarQuickFilters;
